import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@uhg-abyss/web/ui/Link';
import { Text } from '@uhg-abyss/web/ui/Text';
import { useModal } from '@src/state/modal';
import { RenderHtml } from '@src/common/RenderHtml';
import { styled } from '@uhg-abyss/web/tools/styled';
import {
  handleLinkClickFunction,
  getAppLinkHandler,
} from '@sde/widgets-core/src/tools/linkHelperFunctions';

const StyledAppName = styled('div', {
  fontSize: '$md',
  fontWeight: '$bold',
});

const StyledAppLink = styled(Link, {
  textAlign: 'left',
});

const StyledAppDescription = styled(Text, {
  color: '$black',
  whiteSpace: 'pre-wrap',
  '&.abyss-text-root': {
    lineHeight: '17px',
  },
});

const AppLinks = styled('div', {
  padding: '10px 12px 0px',
  '&:last-child': {
    paddingBottom: '20px',
  },
});

export const ApplicationLink = ({
  dataTestId,
  appName,
  appLink,
  appDescription,
  isExternalLink,
  isInternalLink,
  onClick,
  show,
  hasPermission,
  queryParamData,
  queryParam,
  isSuperUser,
  isUhcInsightsUser,
  isInternal,
}) => {
  if (!show) {
    return null;
  }

  const { toggleModal } = useModal.actions();

  const redirect = getAppLinkHandler(appLink, queryParam, queryParamData);

  return (
    <AppLinks>
      <StyledAppName>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <StyledAppLink
          data-testid={dataTestId}
          onClick={() =>
            handleLinkClickFunction({
              hasPermission,
              toggleModal,
              isInternalLink,
              name: appName,
              redirect,
              isSuperUser,
              isUhcInsightsUser,
              onClick,
              isInternal,
              componentName: 'ApplicationLink',
            })
          }
          fontWeight='bold'
          openNewWindow={isExternalLink}
        >
          {appName}
        </StyledAppLink>
      </StyledAppName>
      <If condition={appDescription}>
        <StyledAppDescription size='$sm'>
          <RenderHtml>{appDescription}</RenderHtml>
        </StyledAppDescription>
      </If>
    </AppLinks>
  );
};

ApplicationLink.propTypes = {
  dataTestId: PropTypes.string.isRequired,
  appName: PropTypes.string.isRequired,
  appLink: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  appDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  isExternalLink: PropTypes.bool,
  isInternalLink: PropTypes.bool,
  onClick: PropTypes.func,
  show: PropTypes.bool,
  hasPermission: PropTypes.bool,
  queryParamData: PropTypes.shape({}),
  queryParam: PropTypes.string,
  isSuperUser: PropTypes.bool,
  isUhcInsightsUser: PropTypes.bool,
  isInternal: PropTypes.bool,
};

ApplicationLink.defaultProps = {
  appLink: '',
  appDescription: '',
  isExternalLink: true,
  isInternalLink: false,
  onClick: () => {},
  show: true,
  hasPermission: true,
  queryParamData: null,
  queryParam: null,
  isSuperUser: false,
  isUhcInsightsUser: false,
  isInternal: false,
};
